import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { DRxTheme, DataGridListStyle, HtmlTooltip } from "../../Theme";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect, useState } from "react";
import {
  DrugPopulate,
  DrugSearchAlternativesAndVarients,
} from "../../Apis/AuthApiServices";
import { v4 as uuid } from "uuid";
import NoRecords from "../NoRecords";
import InfoIcon from "../../images/icons/InfoIcon.svg";
import ErrorOverlay from "../ErrorOverlay";
import { Navigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { loadingTopRibbon } from "../../Redux/Slice/TopRibbonSlice";

export default function DrugDataList(props: any) {
  const {
    passingBodyData,
    setDrugDescShow,
    handleHidePopupClick,
    setDrugPopulateData,
    SetFree,
    free,
    setStateData,
  } = props;

  const DrugSearchAjaxState = useSelector((state: any) => {
    return { ...state.DrugSearchAjaxSlice };
  }); //redux data

  const NoRecordsForDrug = () => {
    return (
      <>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          style={{ height: "100%" }}
        >
          <Typography
            fontWeight={"bold"}
            fontStyle={"italic"}
            color={"primary"}
          >
            {passingBodyData?.drugName ? (
              <>No matching drugs found for {passingBodyData?.drugName}</>
            ) : (
              <>Please enter a drug name to search for matching records</>
            )}
          </Typography>
        </Grid>
      </>
    );
  };

  const NoRecordsForAlternatives = () => {
    return (
      <>
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          style={{ height: "100%" }}
        >
          <Typography
            fontWeight={"bold"}
            fontStyle={"italic"}
            color={"primary"}
          >
            {passingBodyData?.drugName ? (
              <>
                No matching alternative drugs found for{" "}
                {passingBodyData?.drugName}
              </>
            ) : (
              <>Please enter a drug name to search for matching records</>
            )}
          </Typography>
        </Grid>
      </>
    );
  };

  const drugCol: GridColDef[] = [
    {
      field: "drugInfoDescription",
      headerName: "Drug Description",
      width: 250,
      cellClassName: "w55",
      headerClassName: "w55",
      renderCell: ({ row }) => (
        <>
          <Typography className="textwrap">
            <Typography
              component="div"
              variant="body2"
              color={UserServiceState?.profileGroup !== 11 ? "primary" : ""}
              onDoubleClick={() => {
                if (UserServiceState?.profileGroup !== 11) {
                  getDrugPopulate(row);
                  setDrugDescShow(true);
                }
              }}
            >
              {row?.drugInfoDescription ?? "N/A"}{" "}
            </Typography>
            <HtmlTooltip
              placement="right"
              arrow
              title={<DrugDescTooltip row={row} />}
            >
              <IconButton className="tooltip">
                <img src={InfoIcon} alt="Tooltip" />
              </IconButton>
            </HtmlTooltip>
          </Typography>
        </>
      ),
    },
    {
      field: "drugtype",
      headerName: "Type",
      width: 70,
      cellClassName: "w8",
      headerClassName: "w8",
      renderCell: ({ row }: any) => (
        <Typography style={{ wordBreak: "break-word" }} variant="body2">
          {row.drugtype === "Branded" ? "B" : "G"}
        </Typography>
      ),
    },
    {
      field: "rxOtc",
      headerName: "Rx/OTC",
      width: 70,
      cellClassName: "w8",
      headerClassName: "w8",
    },
    {
      field: "formularyStatus",
      headerName: "Fmlry. Status",
      width: 250,
      cellClassName: "w25",
      headerClassName: "w25",
    },
    {
      field: "copay",
      headerName: "Copay",
      width: 250,
      cellClassName: "w25",
      headerClassName: "w25",
    },
  ];
  const UserServiceState = useSelector((state: any) => {
    return { ...state?.UserServicesSlice?.ServicesData };
  }); //redux data
  const [data, setData] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [populateLoader, setPopulateLoader] = useState(false);
  const [error, setError] = useState(false);
  const dispatch = useDispatch();

  const getAlternativesAndVariants = useCallback(async () => {
    try {
      setLoading(true);
      const bodyData = {
        prescriptionForm: passingBodyData,
        patientId: sessionStorage.getItem("patientId"),
        userDetails: {
          doctorId: localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await DrugSearchAlternativesAndVarients(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        setData(result?.data?.response);
        setLoading(false);
        setError(false);
      } else {
        if (result?.data?.digitalRxStatusMessage === "Invalid token") {
          <Navigate
            to="/"
            state={{ message: "Your Session is expired! Please LogIn" }}
          />;
        }
        setData([]);
        setLoading(false);
        setError(false);
      }
    } catch (err) {
      setData([]);
      setLoading(false);
      setError(true);
    }
  }, []);

  const getDrugPopulate = useCallback(async (doubleClickedDrugData: any) => {
    try {
      setPopulateLoader(true);
      const {
        drugId,
        initQtyQualifierListFlag,
        drugDescription,
        dispensibleDrugId,
        sig,
        sigFreqId,
        sigDeliveryId,
        sigDoseId,
        sigDoseUnitsId,
        sigTimeNight,
        sigTimeMorning,
        sigTimeEvening,
        sigTimeBeforeMeals,
        igTimeBeforeBed,
        sigTimeNoon,
        sigTimeBedTime,
        sigTimeAfterMeals,
        ...remainData
      } = passingBodyData;
      const bodyData = {
        prescriptionForm: {
          drugId: doubleClickedDrugData?.drugId,
          initQtyQualifierListFlag: false,
          dispensibleDrugId: doubleClickedDrugData?.dispensibleDrugId,
          sig: "",
          sigFreqId: "",
          sigDeliveryId: "",
          sigDoseId: "",
          sigDoseUnitsId: "",
          sigTimeNight: "",
          sigTimeMorning: "",
          sigTimeEvening: "",
          sigTimeBeforeMeals: "",
          igTimeBeforeBed: "",
          sigTimeNoon: "",
          sigTimeBedTime: "",
          sigTimeAfterMeals: "",
          ...remainData,
          // rxhubPBMUniqueId: passingBodyData?.rxhubPBMUniqueId,
          // rxhubPBMUniqueIdOptions: passingBodyData?.rxhubPBMUniqueIdOptions,
          // rxNumber: JSON.parse(sessionStorage.getItem("TabValue")!) ?? "1",
        },
        prescriptionFormList:
          JSON.parse(sessionStorage.getItem("rxTabs") ?? "[]")?.length > 1
            ? JSON.parse(sessionStorage.getItem("rxTabs")!)?.filter(
                (t: any) => t?.drugId != null
              )
            : [],
        patientId: sessionStorage.getItem("patientId"),
        userDetails: {
          userId: localStorage.getItem("LoginUserID"),
          doctorId:
            UserServiceState?.profileGroup > 6
              ? localStorage.getItem("SupervisorDoctorId")
              : localStorage.getItem("doctorId"),
          onBehalfDoctorId: localStorage.getItem("onBehalf") ?? "",
          selectedClinicId: sessionStorage.getItem("clinicId"),
        },
      };
      const result = await DrugPopulate(bodyData);
      if (result?.data?.digitalRxStatusCode === 200) {
        dispatch(loadingTopRibbon());
        setPopulateLoader(false);
        setDrugPopulateData(result?.data?.response);
        handleHidePopupClick();
        SetFree(!free);
        passingBodyData.freeText = true;
      } else {
        if (result?.data?.digitalRxStatusMessage === "Invalid token") {
          <Navigate
            to="/"
            state={{ message: "Your Session is expired! Please LogIn" }}
          />;
        }
        setStateData((prevState: any) => {
          return {
            ...prevState,
            message: result?.data?.digitalRxStatusMessage,
            variant: "error",
            open: true,
          };
        });
        handleHidePopupClick();
        setPopulateLoader(false);
        setDrugPopulateData([]);
      }
    } catch (er) {
      setPopulateLoader(false);
      setDrugPopulateData([]);
    }
  }, []);

  useEffect(() => {
    getAlternativesAndVariants();
  }, [getAlternativesAndVariants]);

  useEffect(() => {
    if (DrugSearchAjaxState?.error) {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: DrugSearchAjaxState?.message,
          variant: "error",
          open: true,
        };
      });
    } else {
      setStateData((prevState: any) => {
        return {
          ...prevState,
          message: DrugSearchAjaxState?.message,
          variant: "error",
          open: false,
        };
      });
    }
  }, [DrugSearchAjaxState?.error]);

  if (populateLoader)
    return (
      <Grid
        container
        justifyContent={"center"}
        alignItems={"center"}
        height={"30vh"}
      >
        <CircularProgress color="primary" />
      </Grid>
    );

  return (
    <Grid
      container
      item
      xs={12}
      spacing={0}
      alignItems="center"
      justifyContent="center"
    >
      {loading ? (
        <Grid
          container
          justifyContent={"center"}
          alignItems={"center"}
          height={"30vh"}
        >
          <CircularProgress color="primary" />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Typography fontWeight={"bold"} variant="body2">
            *TYPE:{" "}
            <Typography fontWeight={600} variant="caption">
              G - Generic, B - Branded
            </Typography>
          </Typography>{" "}
          <DataGridListStyle>
            <DataGrid
              rows={data[0]?.drugSearchResult ?? []}
              sortingOrder={["desc", "asc"]}
              columns={drugCol}
              autoHeight
              rowHeight={40}
              getRowId={(row) => row.drugId ?? uuid()}
              headerHeight={36}
              pageSize={10}
              disableSelectionOnClick
              autoPageSize
              rowsPerPageOptions={[10]}
              loading={loading}
              components={{
                NoRowsOverlay: NoRecordsForDrug,
                NoResultsOverlay: NoRecords,
                ErrorOverlay: ErrorOverlay,
              }}
              error={error || undefined}
            />
          </DataGridListStyle>
          {data[0]?.alternativeDrug?.length > 0 && (
            <>
              <Typography
                component="div"
                variant="body1"
                marginBottom={2}
                fontWeight={600}
              >
                Alternatives for {data[0]?.drugSearchResult[0]?.drugName}
              </Typography>
              <DataGridListStyle>
                <DataGrid
                  rows={data[0]?.alternativeDrug ?? []}
                  sortingOrder={["desc", "asc"]}
                  columns={drugCol}
                  autoHeight
                  rowHeight={40}
                  headerHeight={36}
                  getRowId={(row) => row.drugId ?? uuid()}
                  autoPageSize
                  pageSize={10}
                  disableSelectionOnClick
                  rowsPerPageOptions={[10]}
                  loading={loading}
                  components={{
                    NoRowsOverlay: NoRecordsForAlternatives,
                    NoResultsOverlay: NoRecords,
                    ErrorOverlay: ErrorOverlay,
                  }}
                  error={error || undefined}
                />
              </DataGridListStyle>
              {/* <Typography
                component="div"
                variant="body1"
                marginTop={2}
                marginBottom={2}
                fontWeight={600}
                color={DRxTheme.palette.primary.main}
              >
                * Payer/PBM Specified Alternatives
              </Typography> */}
            </>
          )}
        </Grid>
      )}
      {/* {data[0]?.alternativeDrug?.length > 0 && (
        <>
          <Grid item xs={12} md={4}>
            {" "}
            <Typography
              component="span"
              variant="body1"
              marginTop={2}
              marginBottom={2}
              fontWeight={600}
            >
              *- Therapeutical Alternatives
            </Typography>
          </Grid>
          <Grid item xs={12} md={4}>
            {" "}
            <Typography
              component="span"
              variant="body1"
              marginTop={2}
              marginBottom={2}
              fontWeight={600}
            >
              **- Payer/PBM Specified Alternatives
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            {" "}
            <Typography
              component="span"
              variant="body1"
              marginTop={2}
              marginBottom={2}
              fontWeight={600}
            >
              G - Generic
            </Typography>
          </Grid>
          <Grid item xs={12} md={2}>
            {" "}
            <Typography
              component="span"
              variant="body1"
              marginTop={2}
              marginBottom={2}
              fontWeight={600}
            >
              B - Branded
            </Typography>
          </Grid>
        </>
      )} */}
    </Grid>
  );
}

function DrugDescTooltip(prop: any) {
  const { row } = prop;
  return (
    <Grid container rowSpacing={1} columnSpacing={2}>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Name:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.drugName ? "Not Available" : row.drugName}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Drug Type:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.drugtype ? "Not Available" : row.drugtype}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dose:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.strength ? "Not Available" : row.strength}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dosage Form:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.doseForm ? "Not Available" : row.doseForm}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Route:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.route ? "Not Available" : row.route}
        </Typography>
      </Grid>

      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Instructions:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.instructions ? "Not Available" : row.instructions}
        </Typography>
      </Grid>
      <Grid item xs={12} md={4}>
        <Typography component={"div"} variant={"body2"} fontWeight={600}>
          Dose Unit:
        </Typography>
      </Grid>
      <Grid item xs={12} md={8}>
        <Typography component={"div"} variant={"body2"}>
          {!row.strengthUnit ? "Not Available" : row.strengthUnit}
        </Typography>
      </Grid>
    </Grid>
  );
}
